import {lazy} from "react";

export const AreaSearchLazy = lazy(() => import('./AreaSearch'))